const messages = {
  title: "CENIKI IN BROŠURE IZDELKA",
  description:
    "Prenesite tukaj najnovejše brošure in letake o naših Bridgestone in Firestone pnevmatikah za osebna vozila, SUV-je in kombije.",
  brochureCategories: {
    products: "Izdelki",
    brand_and_solutions: "Blagovna znamka in rešitve",
    season_and_promotions: "Sezona in promocije",
    format: "Format",
    cars_and_vans: "Osebno vozilo in kombi",
    summer: "Poletje",
    winter: "Zima",
    promotions: "Promocije",
    all_season: "Vse sezone",
    truck_and_buses: "Tovornjaki in avtobusi",
    motorcycle: "Motocikel",
    agriculture: "Kmetijstvo",
    construction_machinery: "Gradbena mehanizacija",
    bridgestone: "Bridgestone",
    firestone: "Firestone",
    bandag: "Bandag",
    bleetcare: "Fleetcare",
    webfleet: "Webfleet",
    material: "Materiali",
    brochures: "Brošure izdelkov",
    price_list: "Ceniki",
    materials: "Materiali",
    video_in_store: "Video s podnapisi",
    video_online: "Video brez podnapisov",
    banner_website: "Pasica",
    banner_social_media: "Družbene mreže",
    logos: "Logotipi",
  },
  searchMedia: "Vnesite ključno besedo",
  searchResults: "Rezultati iskanja",
};

export default {
  messages,
};
